import { Component, Input, OnInit, TemplateRef, ChangeDetectorRef } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'lm-full-panel-container',
  templateUrl: './full-panel-container.component.html',
  styleUrls: ['./full-panel-container.component.less'],
  animations: [
    trigger('openClose', [
      transition(':enter', [
        style({ transform: 'translateX(-130%)' }),
        animate('200ms ease-out', style({ transform: 'translateX(0)' }))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ transform: 'translateX(-130%)' }))
      ])
    ])
  ]
})
export class FullPanelContainerComponent implements OnInit {
  private _isVisible = false;

  @Input() currentTemplate: TemplateRef<any> | null = null;

  @Input('isVisible')
  set isVisible(value: boolean) {
    this._isVisible = value;
  }
  get isVisible() { return this._isVisible; }

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {}
}
